module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-klasa6-powtorkomat-3.2ce81305.jpg";